import { promisifyRoutine } from 'redux-saga-routines'
import { createRoutine } from '../../utils/routines'

export const verificationRoutine =  createRoutine('AccountVerification')
export const createVerificationPromise = promisifyRoutine(verificationRoutine)
